import { call, put, takeLatest, delay } from 'redux-saga/effects';
import lgspLogService from '../../../services/lgspLogService';
import api from '../../../utils/api';
import config from '../../../config';
import {
  fetchLogs,
  fetchLogsSuccess,
  fetchLogsFailure,
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchUnits,
  fetchUnitsSuccess,
  fetchUnitsFailure,
  fetchDevicesByUnit,
  fetchDevicesByUnitSuccess,
  fetchDevicesByUnitFailure,
  verifyCitizen,
  verifyCitizenSuccess,
  verifyCitizenFailure,
  exportToExcel,
  exportToExcelSuccess,
  exportToExcelFailure,
  fetchReport,
  fetchReportSuccess,
  fetchReportFailure,
} from './slice';

function* handleFetchLogs(action) {
  try {
    const response = yield call(lgspLogService.getLogs, action.payload);
    yield put(fetchLogsSuccess(response));
  } catch (error) {
    yield put(fetchLogsFailure(error.message));
  }
}

function* handleFetchInit() {
  try {
    const response = yield call(lgspLogService.getInit);
    yield put(fetchInitSuccess(response));
  } catch (error) {
    yield put(fetchInitFailure(error.message));
  }
}

function* handleFetchUnits() {
  try {
    const response = yield call(api.get, config.endpoints.units.list, { pageSize: 999 });
    yield put(fetchUnitsSuccess(response));
  } catch (error) {
    yield put(fetchUnitsFailure(error.message));
  }
}

function* handleFetchDevicesByUnit(action) {
  try {
    const { unitId } = action.payload;
    const response = yield call(api.get, config.endpoints.devices.list, {
      unitId,
      pageSize: 999
    });
    yield put(fetchDevicesByUnitSuccess(response));
  } catch (error) {
    yield put(fetchDevicesByUnitFailure(error.message));
  }
}

function* handleVerifyCitizen(action) {
  try {
    const response = yield call(lgspLogService.verifyCitizen, action.payload);
    yield put(verifyCitizenSuccess(response));
  } catch (error) {
    yield put(verifyCitizenFailure(error.message));
  } finally {
    // Always reload logs after verification attempt (success or failure)
    yield delay(500); // Wait a bit for the log to be saved
    yield put(fetchLogs({
      page: 1,
      pageSize: 10,
      sortColumn: 'requestTime',
      sortDirection: 'desc'
    }));
  }
}

function* handleExportToExcel(action) {
  try {
    yield call(lgspLogService.exportToExcel, action.payload);
    yield put(exportToExcelSuccess());
  } catch (error) {
    yield put(exportToExcelFailure(error.message));
  }
}

function* handleFetchReport(action) {
  try {
    const response = yield call(lgspLogService.getReport, action.payload);
    yield put(fetchReportSuccess(response));
  } catch (error) {
    yield put(fetchReportFailure(error.message));
  }
}

export function* watchLGSPIntegrationActions() {
  yield takeLatest(fetchLogs.type, handleFetchLogs);
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchUnits.type, handleFetchUnits);
  yield takeLatest(fetchDevicesByUnit.type, handleFetchDevicesByUnit);
  yield takeLatest(verifyCitizen.type, handleVerifyCitizen);
  yield takeLatest(exportToExcel.type, handleExportToExcel);
  yield takeLatest(fetchReport.type, handleFetchReport);
}
